 

import AboutHero from './AboutHero';
import AboutText from './AboutText';
 
import AboutBody from './AboutBody';
const About = () => {
  return (
    <>
    <AboutHero/>
    <AboutText/>
    <AboutBody/>
    </>
  );
};

export default About;